export const expertSignin_style = {
  rootSx: {
    borderRadius: '24px 24px 0px 0px',
    px: 2.5,
    pt: 3,
    pb: 4,
    bgcolor: '#FDFFFF',
    // display: 'grid',
    // gap: 2,
    height: '74vh',
  },
  titleSx: {
    color: 'text.primary',
    fontSize: '20px',
    fontWeight: 600,
  },
  forgotpasswordSx: {
    float: 'right',
    marginTop: '10px',
    fontWeight: 600,
    fontSize: '14px',
    cursor: 'pointer',
    opacity: 1,
    textAlign: 'end',
    color: '#6552CC',
    textDecoration: 'none',
  },
  buttonsStyle: {
    textTransform: 'none',
    height: '40px',
  },
  eyeSx:{
    color:'#848484'
  }
};
